<template>
  <div class="page-main">
    <div>
      <div class="flex flex-y-center flex-x-between m-b-10">
        <div class="flex flex-y-center">
          <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="searchListData">
            <span>订单交期:</span>
            <e-date-picker
              type="daterange"
              :value.sync="filterData.jiao_huo_ri_qi"
              isShowFast
              @change="searchListData"
            />
          </el-form>
        </div>
      </div>
      <!-- 表格 -->
      <vxe-grid
        ref="refTable"
        :show-footer="!!tableData.length"
        :loading="loading"
        :columns="tableColumn"
        :data="tableData"
        :height="this.$util.getViewHeight() - 36 - 148"
        :footer-method="footerMethod"
        :cell-class-name="cellClassName"
        @cell-dblclick="itemDbDo"
        @resizable-change="handleColumnResize"
        @keydown="tableKeydown"
        @current-change="tableCurrentChange"
      >
        <!-- slot_header -->
        <template #header_input="{ column }">
          <c-table-header
            :title="column.title"
            :field="column.field"
            :url="headerFilterUrl"
            :filterData="filterData"
            @change="headerFilterChange"
          />
        </template>
        <template #header_daterange="{ column }">
          <c-table-header
            type="daterange"
            :title="column.title"
            :field="column.field"
            :url="headerFilterUrl"
            :filterData="filterData"
            :value.sync="filterData[column.field]"
            @change="headerFilterChange"
          />
        </template>
        <!-- 是否已打印-筛选 -->
        <template #header_is_print="{ column }">
          <div class="header-filter-box">
            <div>{{ column.title }}</div>
            <el-select
              v-model="filterData.is_print"
              size="mini"
              placeholder="全部"
              clearable
              style="width: 80px"
              @change="searchListData"
            >
              <el-option label="已打印" value="1" />
              <el-option label="未打印" value="0" />
            </el-select>
          </div>
        </template>

        <!-- slot_default -->
        <!-- resultStart -->
        <template #default_gong_dan_code="{ row }">
          <el-link type="primary" @click="itemDo(row.id)">
            {{ row.gong_dan_code }}
          </el-link>
        </template>
        <template #default_list_chan_pin_tu="{ row }">
          <e-upload-image v-if="row.list_chan_pin_tu" :list.sync="row.list_chan_pin_tu" disabled />
        </template>

        <!-- resultOrderNo -->
        <template #default_list_gong_cheng_tu="{ row }">
          <e-upload-image
            v-if="row.list_gong_cheng_tu"
            :list.sync="row.list_gong_cheng_tu"
            disabled
          />
        </template>
        <template #default_list_yuan_wen_jian="{ row }">
          <e-upload-file
            v-if="row.list_yuan_wen_jian"
            :list.sync="row.list_yuan_wen_jian"
            disabled
          />
        </template>
        <template #default_list_jian_ce_mu_ban="{ row }">
          <e-upload-file
            v-if="row.list_jian_ce_mu_ban"
            :list.sync="row.list_jian_ce_mu_ban"
            disabled
          />
        </template>
        <template #default_list_jian_ce_bao_gao="{ row }">
          <e-upload-file
            v-if="row.list_jian_ce_bao_gao"
            :list.sync="row.list_jian_ce_bao_gao"
            disabled
          />
        </template>
        <template #default_jin_du="{ row }">
          <div class="flex flex-center">
            <div
              class="flex flex-y-center"
              v-for="(item, index) in diffSearchTypeShowData.list"
              :key="index"
            >
              <span v-if="index">-</span>
              <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
              <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
              <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
            </div>
          </div>
        </template>

        <!-- resultEnd -->
        <!-- 是否已打印-显示 -->
        <template #default_is_print="{ row }">
          <el-tag v-if="row.is_print" type="success" size="mini">已打印</el-tag>
          <el-tag v-else type="danger" size="mini">未打印</el-tag>
        </template>
        <template #default_operate="{ row }">
          <el-dropdown>
            <el-button type="default" size="mini">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="itemDo(row.id)">
                <span class="c-blue">编辑</span>
              </el-dropdown-item>
              <el-dropdown-item @click.native="itemPrint(row)"> 打印 </el-dropdown-item>
              <el-dropdown-item v-if="isAdmin" @click.native="itemDelete(row)">
                <span class="c-red">删除</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>

        <!-- slot_pager -->
        <template #pager>
          <div></div>
          <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
        </template>
      </vxe-grid>
    </div>

    <!-- 弹窗-核算单 -->
    <PopupDo
      v-if="isShowPopupDo"
      :show.sync="isShowPopupDo"
      :detailId="activeDetailId"
      @success="updatePage"
    />

    <!-- 弹窗-制造明细 -->
    <b-popup-verify-goods-detail
      v-if="isShowPopupVerifyGoodsDetail"
      :show.sync="isShowPopupVerifyGoodsDetail"
      :id="activeBillId"
      :isVerify="false"
    />

    <!-- 弹窗-制造流程 -->
    <b-popup-verify-goods-view
      v-if="isShowPopupVerifyGoodsView"
      :show.sync="isShowPopupVerifyGoodsView"
      :id="activeBillId"
      :isVerify="false"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_weiwai_page_list',
  components: {
    PopupDo: () => import('../common/popup-do/index')
  },
  data() {
    return {
      // loading
      loading: true,

      // filter
      filterData: {
        gong_dan_code: '',
        bill_code: '',
        fu_ze_ren_name: '',
        processor_name: '',
        processor_fu_ze_ren: '',
        processor_phone: '',
        jiao_huo_ri_qi: [this.$util.getDate().monthStart, this.$util.getDate().monthEnd],
        sheng_chan_end_date: [],
        gongxu_name: '',
        spec: '',
        unit: '',
        counts: '',
        goods_price: '',
        goods_amount: '',
        get_counts: '',
        sheng_chan_end_counts: '',
        is_print: ''
      },
      sortData: {},

      // table
      headerFilterUrl: '/admin/gcvip/weiWaiGongDan/searchHeard',
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        dai_shou_li_count: '',
        shou_li_zhong_count: '',
        yi_wan_jie_count: '',
        counts_all: '',
        goods_amount_all: '',
        sheng_chan_end_counts_all: ''
      },

      // popup
      isShowPopupDo: false,
      isShowPopupVerifyGoodsDetail: false,
      isShowPopupVerifyGoodsView: false,
      activeBillId: null,
      activeDetailId: null
    }
  },
  computed: {
    // 是否是管理员
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    // 当前登录账号id
    accountId() {
      return this.$store.state.loginAccount.id
    },
    // 表格列
    tableColumn() {
      let result = [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          fixed: 'left',
          title: '工单编号',
          field: 'gong_dan_code',
          slots: { header: 'header_input', default: 'default_gong_dan_code' }
        },
        {
          title: '销售单号',
          field: 'bill_code',
          slots: { header: 'header_input' }
        },
        {
          title: '负责人',
          field: 'fu_ze_ren_name',
          slots: { header: 'header_input' }
        },
        {
          title: '加工商',
          field: 'processor_name',
          slots: { header: 'header_input' }
        },
        {
          title: '加工商负责人',
          field: 'processor_fu_ze_ren',
          slots: { header: 'header_input' }
        },
        {
          title: '加工商电话',
          field: 'processor_phone',
          slots: { header: 'header_input' }
        },
        {
          title: '订单交期',
          field: 'jiao_huo_ri_qi',
          width: 180,
          slots: { header: 'header_daterange' },
          formatter: ({ row }) => {
            return row.jiao_huo_ri_qi ? row.jiao_huo_ri_qi.slice(0, 10) : '-'
          }
        },
        {
          title: '生产交期',
          field: 'sheng_chan_end_date',
          width: 180,
          slots: { header: 'header_daterange' },
          formatter: ({ row }) => {
            return row.sheng_chan_end_date ? row.sheng_chan_end_date.slice(0, 10) : '-'
          }
        },
        {
          title: '工艺图片',
          field: 'list_chan_pin_tu',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '工艺名称',
          field: 'gongxu_name',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '单位',
          field: 'unit',
          width: 60,
          slots: { header: 'header_input' }
        },
        {
          title: '数量',
          field: 'counts',
          slots: { header: 'header_input' }
        },
        {
          title: '单价(元)',
          field: 'goods_price',
          slots: { header: 'header_input' }
        },
        {
          title: '金额(元)',
          field: 'goods_amount',
          slots: { header: 'header_input' }
        },
        {
          title: '领料数',
          field: 'get_counts'
        },
        {
          title: '报工数',
          field: 'sheng_chan_end_counts',
          slots: { header: 'header_input' }
        },
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' }
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' }
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' }
        },
        {
          fixed: 'right',
          title: '是否已打印',
          field: 'is_print',
          width: 100,
          slots: { header: 'header_is_print', default: 'default_is_print' }
        },
        {
          fixed: 'right',
          title: '操作',
          slots: { default: 'default_operate' },
          width: 80
        }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // 列宽变化，保存单列宽度
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 更新页面
    updatePage() {
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        filterData: this.filterData,
        sortData: this.sortData
      }

      this.$api({
        method: 'post',
        url: '/admin/gcvip/weiWaiGongDan/list',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            let list = this.$util.deepCopy(data.list)
            this.tableData = list

            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber

            this.totalObj.dai_shou_li_count = res.data.dai_shou_li_count
            this.totalObj.shou_li_zhong_count = res.data.shou_li_zhong_count
            this.totalObj.yi_wan_jie_count = res.data.yi_wan_jie_count
            this.totalObj.counts_all = res.data.counts_all
            this.totalObj.goods_amount_all = res.data.goods_amount_all
            this.totalObj.sheng_chan_end_counts_all = res.data.sheng_chan_end_counts_all
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'counts') return this.totalObj.counts_all
          if (column.field === 'goods_amount') return this.totalObj.goods_amount_all
          if (column.field === 'sheng_chan_end_counts')
            return this.totalObj.sheng_chan_end_counts_all
        })
      ]
    },
    // 行类名计算，实现按字段分组的斑马纹效果
    cellClassName(rowData) {
      let result = this.$tool.getTableCellClassName(this.tableData, rowData, 'bill_id')
      return result
    },

    // 项-制造明细
    itemMadeDetail(id) {
      this.activeBillId = id
      this.isShowPopupVerifyGoodsDetail = true
    },
    // 项-制造流程
    itemMadeView(id) {
      this.activeBillId = id
      this.isShowPopupVerifyGoodsView = true
    },
    // 项-增改
    itemDo(id) {
      this.activeDetailId = id
      this.isShowPopupDo = true
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDo(val.row.id)
    },
    // 项-打印制造流程
    itemPrint(row) {
      let url = `/new/weiwai/print?id=${row.id}`
      window.open(url, '_blank')
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm(`工单编号：${row.gong_dan_code}，是否删除该工单?`, '提示')
        .then(() => {
          this.itemDeleteConfirm(row.id)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    itemDeleteConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/weiWaiGongDan/delete',
        params: {
          id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('操作成功')
            this.getListData()
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
// 是否已打印表头筛选样式，与 c-table-header 保持一致
.header-filter-box {
  color: @colorGrayDeep;
  .el-select {
    margin-top: 2px;
    /deep/ .el-input__inner {
      height: 24px;
      line-height: 24px;
      color: @colorGrayDeep;
      width: 100% !important;
      overflow: hidden;
      padding: 0 2px;
      text-align: center;
    }
    // 下拉箭头图标随输入框高度垂直居中
    /deep/ .el-input__icon {
      width: auto;
      line-height: 24px;
    }
    // 箭头区域白底，避免与居中文字重叠时透底
    /deep/ .el-input__suffix-inner {
      background: #fff;
    }
  }
}
</style>
